import { createBrowserRouter, createRoutesFromElements } from "react-router";
import { routes } from "@/RouterComponent";
import { registerRouter } from "@/utils/navigation";

export const router = createBrowserRouter(createRoutesFromElements(routes));

// Lets redux thunks navigate without reaching for a history singleton.
registerRouter(router);
